import * as types from './mutation-types.js'

const mutations = {
  [types.SET_FEATURE_FLAGS] (state, featureFlags) {
    state.featureFlags = featureFlags
  },
  [types.CLEAR_ORG_PODCASTS] (state) {
    state.orgPodcasts = []
    state.orgPodcastsCount = 0
  },
  [types.CLEAR_USER_INVITES] (state) {
    state.userInvites = []
  },
  [types.SET_ORG_PODCASTS] (state, podcasts) {
    state.orgPodcasts = podcasts
  },
  [types.SET_ORG_PODCASTS_COUNT] (state, podcastCount) {
    state.orgPodcastsCount = podcastCount
  },
  [types.SET_ORG_PODCASTS_TOTAL] (state, podcastCount) {
    state.orgPodcastsTotal = podcastCount
  },
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_USER_PREFERENCES] (state, preferences) {
    state.user.preferences = preferences
  },
  [types.SET_ACCOUNT] (state, account) {
    state.user.accounts.collection = state.user.accounts.collection.map(a => a.id !== account.id ? a : account)
  },
  [types.SET_ACCOUNT_API_KEY] (state, accountApiKey) {
    state.accountApiKey = accountApiKey
  },
  [types.SET_CURRENT_ACCOUNT] (state, account) {
    state.currentAccount = account
  },
  [types.SET_ACCOUNT_NAV] (state, nav) {
    state.currentAccountNav = nav
  },
  [types.UPDATE_ERROR] (state, err) {
    state.updateError = err
  },
  [types.SET_NOTIFICATION] (state, notification) {
    state.notification = notification
  },
  [types.SET_AUTHORIZED_APPS] (state, {apps}) {
    let authorizedApps = {}

    if (Array.isArray(apps.collection)) {
      apps.collection.map((a) => {
        authorizedApps[a.id] = a
      })
    } else {
      authorizedApps = apps.collection
    }

    apps.collection = authorizedApps

    this._vm.$set(state.user, 'authorized_apps', apps)

    state.user.authorized_apps = apps
  },
  [types.SET_PRIVATE_APPS] (state, {account, apps}) {
    let privateApps = {}

    if (Array.isArray(apps.collection)) {
      apps.collection.map((a) => {
        privateApps[a.client_id] = a
      })
    } else {
      privateApps = apps.collection
    }

    apps.collection = privateApps

    state.user.accounts.collection = state.user.accounts.collection.map((a) => {
      if (a.id !== account.id) {
        return a
      }

      a.private_apps = apps

      return a
    })
  },
  [types.SET_USER_INVITES] (state, invites) {
    let allInvites = []
    if (invites.podcast_invitations && invites.podcast_invitations.length) {
      allInvites.push(...invites.podcast_invitations)
    }
    if (invites.team_invitations && invites.team_invitations.length) {
      allInvites.push(...invites.team_invitations)
    }
    state.userInvites = allInvites
  },
  [types.SET_TWO_FACTOR] (state, twoFactor) {
    state.twoFactor = twoFactor
  },
  [types.SET_APPLE_CREDENTIALS] (state, appleCredentials) {
    state.appleCredentials = appleCredentials
  }
}

export default mutations
